import { SET_ERROR } from 'constants/error';

export function setError(error: any, requestType: string) {
  return {
    type: SET_ERROR,
    requestType,
    error,
  };
}
